<div class="release-note-admin-page">
  <div class="pane left-pane">
    <app-release-notes-list [releaseNotes]="releaseNotes" (addClicked)="onAdd()" (editClicked)="onEdit($event)"> </app-release-notes-list>
  </div>

  <div class="pane right-pane">
    <app-release-note-form (refreshList)="onRefreshList()"></app-release-note-form>
  </div>
</div>
